import React, { useState, useRef, useEffect, Fragment } from 'react';
import { Typography, Fab, makeStyles, Theme, createStyles, LinearProgress } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import Constants from '../../types/constants';
import { InEditingMode, IGlobalState, InEditingType } from '../../states/GlobalState';
// import EditUserModeRead from './EditUserModeRead';
import WhatsNewFields from './fields';
import { useGlobal, useDispatch } from 'reactn';
import apiService from '../../services/api'
import { useHistory, useLocation } from 'react-router-dom';
// import { useNotifyUser } from '../../utils/myHooks';
import {CustomDialog} from '../../dialog/CustomDialog';
// import UserService from '../../services/UserService';
// import { useAuthDataContext } from '../../services/auth-data-hooks';
import { WhatsNew } from '../../models/whatsNew';
import { useNotifyUser } from '../../utils/hooks';
import ConfirmDialog from '../../dialog/ConfirmDialog';
import { LoggerServiceProvider, useLogger } from '../../logger';
import { deleteWhatsNew } from '../../services/whatsNewServices';

const contentMaxWidth = Constants.PageEditWhatsNewContentMaxWidth;
const useStyles = makeStyles((theme: Theme) => createStyles({
    locked: {
        color: theme.palette.error.main,
        marginLeft: theme.spacing(2),
    },
    whatsNewheader: {
        display: 'flex',
        maxWidth: contentMaxWidth,
        // flex: '0 0 36px',
        // alignSelf: 'end'
    },
    containerMain: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        paddingTop: '8px'
    },
    fab: {
        marginLeft: theme.spacing(1),
    },
}))

type EditWhatsNewPropsType = {
    initialMode: InEditingMode,
    isGroup?: boolean,
}

export default function WhatsNewEdit({initialMode, isGroup}: EditWhatsNewPropsType) {
    const submitFunctionRef = useRef<() => Promise<any>>(); //Referenza ad una funzione
    const refreshFunctionRef = useRef<() => void>() //Referenza ad una funzione
    const dispatch = useDispatch()
    const [currentEditWhatsNew,] = useGlobal<IGlobalState, 'currentEditWhatsNew'>('currentEditWhatsNew')
    // const [newUserNextOid] = useGlobal<IGlobalState, 'newUserNextOid'>('newUserNextOid')
    const [, setCurrentEditStatus] = useGlobal<IGlobalState, 'currentEditWhatsNewStatus'>('currentEditWhatsNewStatus')
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
    const [/*confirmCloneDialogOpen*/, setConfirmCloneDialogOpen] = useState(false);
    const [working, setWorking] = useState(false)
    const whatsNewEdit = currentEditWhatsNew; 
    // const { adOwnerContext, adLevels } = useAuthDataContext();
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const history = useHistory();
    // const location = useLocation();
    const classes = useStyles();
    const logger = useLogger({key: 'whatsNew'});

    // useEffect(() => {
    //     // Controlliamo se è cambiato l'oid del pathname rispetto all'oid di inedituser
    //     if(currentEditWhatsNew) {
    //         console.log('Sono in edit con current Edit');
    //         console.log('WhatsNew id for current is: ' + currentEditWhatsNew.whatsNew.Id);
    //         if(urloid === currentEditWhatsNew.whatsNew.Id && urloid <= 0) 
    //             setEditMode(InEditingMode.New)
    //         else {
    //             setEditMode(InEditingMode.Edit);
    //         }
    //     }
    //     // TODO
    //     // UserService.clearCache()
    // }, [location, urloid, currentEditWhatsNew])
    //Definisco la callback alla submit
    const handleSetSubmitCallback = (callback: () => Promise<any>) => submitFunctionRef.current = callback;
    const handleSetRefreshCallback = (callback: () => void) => refreshFunctionRef.current = callback;

    // const handleMode = (newmode: InEditingMode) => {
    //     const inedit: InEditingType | null = currentEditWhatsNew
    //     if (inedit) {
    //         if (inedit.mode === InEditingMode.Edit && newmode === InEditingMode.Read && submitFunctionRef.current) {
    //             submitFunctionRef.current().then(() => {
    //                 setEditMode(inedit.mode)
    //             })
    //         } else {
    //             inedit.mode = newmode;
    //             setEditMode(newmode);
    //         }
    //     }
    // }
    const handleSubmit = () => {
        console.log('*** *** *** SUBMIT END *** *** ***');
        // currentEditWhatsNew /*&& setEditMode(currentEditWhatsNew.mode)*/;
    }

    /* Cancellazione */
    const doDelete = (item: WhatsNew) => {
        deleteWhatsNew(ip, auth.authData!, auth.user!, item.Id).then(result => {
            setWorking(true);
            console.log('Deleted whatsNew', result)
            if(result === false) {
                logger.error(`Errore nella cancellazione ${item.Id} [${result}]`);
            } else if(result === true) {
                logger.info(`Cancellazione ${item.Id} riuscita [${result}]`);
            }
            return dispatch.removeInEditWhatsNew(item.Id);
        }).finally(() => { 
            setWorking(false) 
            history.replace('/whatsNew')
        });
    }
    
    const handleDelete = () => {
        console.log('*** +++ handleDelete')
        if(currentEditWhatsNew) {
            setConfirmDialogOpen(true)
        }
    }
    // const handleClone = () => {
    //     console.log('*** +++ handleClone')
    //     if(currentEditWhatsNew) {
    //         setConfirmCloneDialogOpen(true)
    //     }
    // }
    const handleRefresh = () => {
        console.log('*** +++ handleRefresh')
        refreshFunctionRef.current && refreshFunctionRef.current();
        // TODO
        console.log('lo stato diventa pristine');
        setCurrentEditStatus('Pristine');
    }

    const handleBack = () => {
        history.push('/whatsNew');
    }

    const handleSaveNew = () => {
        if(submitFunctionRef.current) {
            console.log('Sto per eseguire la current che è la submitform di Formik');
            submitFunctionRef.current();
        }
    }
    const closeConfirmDialog = (event: {}) => setConfirmDialogOpen(false)
    const closeConfirmCloneDialog = (event: {}) => setConfirmCloneDialogOpen(false)

    const confirmDelete = (context?: any) => {
        setConfirmDialogOpen(false)
        // TODO
        currentEditWhatsNew && doDelete(currentEditWhatsNew.whatsNew);
    }
    
    return (
        <React.Fragment>
            <div className={classes.containerMain}>
                <div className={classes.whatsNewheader}>
                    {/* <Typography variant='h5'>
                        {whatsNewEdit.whatsNew.Id > 0 ? (<small><small><em>({whatsNewEdit.whatsNew.Id > 0 ? whatsNewEdit.whatsNew.Id : 'NUOVO'})</em></small></small>) : null}
                    </Typography> */}
                    <div style={{ flex: '0 1 auto' }}>
                        <Fab color='primary' size='small' className={classes.fab} 
                            onClick={(event) => handleBack()} title='Indietro'><BackIcon /></Fab>
                        <Fab color='secondary' size='small' className={classes.fab} style={{backgroundColor: 'rgba(0, 161, 216, 1.0)' }} 
                            onClick={(event) => handleSaveNew()} title='Salva Modifiche'><SaveIcon /></Fab>
                        {currentEditWhatsNew?.mode !== InEditingMode.New ? (<Fab color='default' size='small' className={classes.fab} 
                            onClick={(event) => handleDelete()} title='Elimina WhatsNew'><DeleteIcon /></Fab>) : null}
                    </div>
                </div>
                {/* here is starting the part of resume WhatsNew */}
                {currentEditWhatsNew ? (
                    <EditFields
                        setSubmitCallback={handleSetSubmitCallback} 
                        setRefreshCallback={handleSetRefreshCallback} 
                        onSubmit={handleSubmit} />
                    ) :
                    <div></div>
                }
            </div>
            {working && <LinearProgress color='primary' />}
            <ConfirmDialog open={confirmDialogOpen} cancel={closeConfirmDialog} confirm={confirmDelete} 
                title={'Cancellazione WhatsNew'} 
                prompt={"Cancello la whatsNew?"}>
                <Fragment>
                    <Typography variant='body1'>{'WhatsNew'} <strong>{whatsNewEdit && whatsNewEdit.whatsNew ? whatsNewEdit.whatsNew.BusinessName : ' insert mode'}</strong></Typography>
                    <p></p>
                </Fragment>
            </ConfirmDialog>
        </React.Fragment>
    );
};

type WhatsNewFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void
}
const EditFields = ({setSubmitCallback, setRefreshCallback, onSubmit}: WhatsNewFieldsPropsType) => {
    return (
        <WhatsNewFields setSubmitCallback={setSubmitCallback} setRefreshCallback={setRefreshCallback} onSubmit={onSubmit} />
    )
}

